import { motion } from "framer-motion";
import { Footprints, Crown, Flame, Zap, Sparkles, Tag, Music2, ShoppingBag } from "lucide-react";

const STICKERS = [
  { Icon: Footprints, text: "SNEAKER CULTURE", className: "left-[3%] top-[20%]", dur: 3.4, rot: -8 },
  { Icon: Crown, text: "STREET ROYALTY", className: "right-[4%] top-[16%]", dur: 4.1, rot: 10 },
  { Icon: Flame, text: "PURE HEAT", className: "left-[6%] bottom-[26%]", dur: 3.8, rot: 6 },
  { Icon: Zap, text: "HIGH VOLTAGE", className: "right-[7%] bottom-[32%]", dur: 3.1, rot: -6 },
];

export function StreetStickers() {
  return (
    <div className="absolute inset-0 pointer-events-none hidden md:block" aria-hidden="true" data-testid="street-stickers">
      {STICKERS.map(({ Icon, text, className, dur, rot }, i) => (
        <motion.div key={text} className={`absolute ${className} pointer-events-auto`}
          initial={{ rotate: rot }}
          animate={{ y: [0, -16, 0], rotate: [rot, rot + 6, rot] }}
          transition={{ duration: dur, repeat: Infinity, ease: "easeInOut", delay: i * 0.4 }}
          whileHover={{ scale: 1.15, rotate: -rot }}
          data-testid={`sticker-${text.toLowerCase().replace(/\s+/g, "-")}`}>
          <div className="flex items-center gap-2 border border-gold/50 bg-ink/70 backdrop-blur px-3 py-2 shadow-[0_0_24px_rgba(212,175,55,0.15)]">
            <Icon size={16} className="text-gold" />
            <span className="text-[10px] font-display font-bold tracking-[0.25em] text-gold">{text}</span>
          </div>
        </motion.div>
      ))}
    </div>
  );
}

const CHIPS = [
  { Icon: ShoppingBag, text: "OVERSIZED FITS" },
  { Icon: Tag, text: "DROP SHOULDER" },
  { Icon: Music2, text: "HIP-HOP DNA" },
  { Icon: Footprints, text: "SNEAKER GAME" },
  { Icon: Flame, text: "LIMITED DROPS" },
  { Icon: Crown, text: "STREET LUXE" },
  { Icon: Zap, text: "BOLD PRINTS" },
  { Icon: Sparkles, text: "GOLD STANDARD" },
];

export function StickerMarquee() {
  return (
    <div className="border-b border-[#262626] bg-ink overflow-hidden py-3" data-testid="sticker-marquee">
      <div className="animate-marquee-reverse whitespace-nowrap flex gap-3 w-max">
        {Array(3).fill(CHIPS).flat().map(({ Icon, text }, i) => (
          <span key={`${text}-${i}`}
            className="inline-flex items-center gap-1.5 border border-[#262626] px-3 py-1.5 text-[10px] tracking-[0.2em] text-muted-foreground uppercase hover:border-gold/60 hover:text-gold transition-colors">
            <Icon size={11} className="text-gold" /> {text}
          </span>
        ))}
      </div>
    </div>
  );
}
